import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';   
import { RegisterStepOneBaseComponent } from '../register-step-one-base.component';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-wingfield-registration',
  templateUrl: './wingfield-registration.component.html',
  styleUrls: ['./wingfield-registration.component.css'],
  standalone: true,
  imports: [ReactiveFormsModule]
})

export class WingfieldRegistrationComponent extends  RegisterStepOneBaseComponent {
    
}
